<template>
  <Icon name="clear" class="w-4 h-4 flex-shrink-0 text-gray-500" />
</template>
